// comment

class ProductInformation extends HTMLElement {
  constructor() {
    super();
    this.data = {};
    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
    this.initThumbSlider();
    this.handleEvents();
    this.handleActionPopup();
    this.initFAQToggle();
    
    // this.handleSizeOption();
    this.addEventListener("click", function (e) {
      let p__btn = e.target.classList.contains("p-info-size-btn")
        ? e.target
        : e.target.closest(".p-info-size-btn");
      if (p__btn) {
        document.querySelector(".pqa-popup").classList.add("active");
        document.querySelector("body").style.height = "100svh";
        document.querySelector("body").style.overflow = "hidden";
        // window.closeOnOutsideClick();
      }
    });
    this.currentZoom = 1;
    this.translateX = 0;
    this.translateY = 0;
    this.initialDistance = 0;
    this.initialZoom = 1;
    this.lastTouchX = 0;
    this.lastTouchY = 0;
    this.zoomSwiper = null;
    this.zoomPopup = null;
    this.customCursor = null;
  }

  connectedCallback() {
    this.querySelector("product-variant-picker").addEventListener(
        "input",
        (e) => {
            this.handleVariantInput(e);
        }
    );

    new Accordion(".prod-info-accrodion-" + this.productId, {
        closeAll: true,
        initOpenIndex: 1,
        duration: 700,
        activeClass: "active",
    });

    this.initZoomListeners();
    // No need for preloaded data - we'll fetch on demand
    this.handleActiveSlide(this.dataset.selectedImage);

    if (typeof scrolltoReviewSection === 'function') {
        window.scrolltoReviewSection(5, 1000);
    } else {
        console.error('scrolltoReviewSection function is not defined');
    }

    this.removeHiddenQuantitySelector();
    
    // Store bound handler for cleanup
    // this.removeHiddenQuantitySelector();
    // window.addEventListener("resize", () => this.removeHiddenQuantitySelector());
    this._removeHiddenQuantitySelectorBound = () => this.removeHiddenQuantitySelector();
    window.addEventListener("resize", this._removeHiddenQuantitySelectorBound);
    
    this.initQuantitySelector();
    this.variantLabelHover();

    // ============================================================
    // INIT STICKY MOBILE PREVIEW
    // ============================================================
    this.initStickyMobilePreview();
  }



  disconnectedCallback() {
    // Clean up quantity selector delegation handler
    if (this._quantityDelegationHandler) {
        const qtyWrapper = this.querySelector('[data-quantity-selector]');
        if (qtyWrapper) {
            qtyWrapper.removeEventListener('click', this._quantityDelegationHandler);
        }
        this._quantityDelegationHandler = null;
    }

    // Clean up form submit listener
    if (this._boundHandleAddToCart) {
        const form = this.querySelector('form[action$="/cart/add"]');
        if (form) {
            form.removeEventListener('submit', this._boundHandleAddToCart);
        }
        this._boundHandleAddToCart = null;
    }

    // Clean up zoom slide click listeners
    this.querySelectorAll('.p-info-thumb-slide').forEach(slide => {
        if (slide._zoomClickHandler) {
            slide.removeEventListener('click', slide._zoomClickHandler);
            slide._zoomClickHandler = null;
        }
    });

    // Destroy Swiper instance
    if (this.thumbSwiper) {
        try {
            this.thumbSwiper.destroy(true, true);
        } catch (e) {
            // Swiper might already be destroyed
        }
        this.thumbSwiper = null;
    }

    // Remove zoom popup if open
    if (this.zoomPopup) {
        this.zoomPopup.remove();
        this.zoomPopup = null;
    }

    // Remove custom cursor
    this.removeCustomCursor();

    // Remove body class
    document.body.classList.remove('overflow-hidden');

    // Clean up sticky mobile preview
    if (this._stickyCleanup) {
        this._stickyCleanup();
        this._stickyCleanup = null;
    }

    // Clean up resize listener
    if (this._removeHiddenQuantitySelectorBound) {
        window.removeEventListener("resize", this._removeHiddenQuantitySelectorBound);
        this._removeHiddenQuantitySelectorBound = null;
    }

    // Clean up quantity input listener
    const qtyWrapper = this.querySelector('[data-quantity-selector]');
    if (qtyWrapper) {
        const input = qtyWrapper.querySelector('.qty-input');
        if (input && input._quantityInputHandler) {
            input.removeEventListener('input', input._quantityInputHandler);
            input._quantityInputHandler = null;
        }
    }

    console.log('[ProductInformation] Cleaned up');
  }

  
  attachVariantPickerListener() {
    const variantPicker = this.querySelector("product-variant-picker");
    if (variantPicker) {
      variantPicker.addEventListener("input", (e) => {
        this.handleVariantInput(e);
      });
    }
  }




  initStickyMobilePreview() {
    // Only on mobile (Beta uses 1200px breakpoint)
    if (window.innerWidth > 1200) return;

    const mediaContainer = document.querySelector('.p-info-sliders');
    const customPlacementWrapper = document.querySelector('.cpc-placement-wrapper.cpc-placement-block-wrapper');
    const body = document.body;

    if (!mediaContainer || !customPlacementWrapper) {
        console.log('[Sticky Preview] Required elements not found');
        return;
    }

    const hasMonogram = !!document.querySelector('.cpc-placement-wrapper');
    if (!hasMonogram) {
        console.log('[Sticky Preview] No monogram customizer found');
        return;
    }

    const thumbSwiper = document.querySelector('.p-info-thumb');
    if (!thumbSwiper) {
        console.log('[Sticky Preview] Thumb swiper not found');
        return;
    }

    function isMonogramSlideActive() {
        const monogramSlide = document.querySelector('.swiper-slide.cpc-monogram-slide-wrapper');
        if (!monogramSlide) return false;
        return monogramSlide.classList.contains('swiper-slide-active');
    }

    function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function doesMonogramSlideExist() {
        return !!document.querySelector('.swiper-slide.cpc-monogram-slide-wrapper');
    }

    function isAtTopOfPage() {
        return window.scrollY <= 50;
    }

    let isSticky = false;
    let scrollTimeout = null;

    function setSticky(shouldSticky) {
        if (shouldSticky === isSticky) return;
        isSticky = shouldSticky;

        if (isSticky) {
            mediaContainer.classList.add('sticky-preview');
            body.classList.add('sticky-monogram-active');
            if (thumbSwiper) {
                thumbSwiper.classList.add('sticky-active');
            }
        } else {
            mediaContainer.classList.remove('sticky-preview');
            body.classList.remove('sticky-monogram-active');
            if (thumbSwiper) {
                thumbSwiper.classList.remove('sticky-active');
            }
        }
    }

    function handleScroll() {
        if (window.innerWidth > 1200) {
            setSticky(false);
            return;
        }

        if (scrollTimeout) {
            cancelAnimationFrame(scrollTimeout);
        }

        scrollTimeout = requestAnimationFrame(() => {
            const atTop = isAtTopOfPage();
            const slideExists = doesMonogramSlideExist();
            const slideActive = isMonogramSlideActive();
            const isInViewport = isElementInViewport(customPlacementWrapper);

            const thumbSwiperEl = document.querySelector('.p-info-thumb');
            let isSlideVisible = false;
            if (thumbSwiperEl && thumbSwiperEl.swiper) {
                const slides = thumbSwiperEl.swiper.slides;
                const activeIndex = thumbSwiperEl.swiper.activeIndex;
                if (slides[activeIndex] && slides[activeIndex].classList.contains('cpc-monogram-slide-wrapper')) {
                    isSlideVisible = true;
                }
            }

            const shouldBeSticky = !atTop && slideExists && (slideActive || isSlideVisible) && isInViewport;
            setSticky(shouldBeSticky);
        });
    }

    function handleResize() {
        if (window.innerWidth > 1200) {
            setSticky(false);
        } else {
            handleScroll();
        }
    }

    function setupSwiperListeners() {
        const thumbSwiperEl = document.querySelector('.p-info-thumb');
        if (thumbSwiperEl && thumbSwiperEl.swiper) {
            if (thumbSwiperEl._stickySlideChangeHandler) {
                thumbSwiperEl.swiper.off('slideChange', thumbSwiperEl._stickySlideChangeHandler);
            }
            
            thumbSwiperEl._stickySlideChangeHandler = function() {
                handleScroll();
            };
            
            thumbSwiperEl.swiper.on('slideChange', thumbSwiperEl._stickySlideChangeHandler);
            
            thumbSwiperEl._stickySlideEndHandler = function() {
                setTimeout(handleScroll, 50);
            };
            
            thumbSwiperEl.swiper.on('slideChangeTransitionEnd', thumbSwiperEl._stickySlideEndHandler);
        }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize, { passive: true });

    setTimeout(setupSwiperListeners, 500);

    const swiperObserver = new MutationObserver(() => {
        setupSwiperListeners();
    });

    const thumbSwiperEl = document.querySelector('.p-info-thumb');
    if (thumbSwiperEl) {
        swiperObserver.observe(thumbSwiperEl, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    const placementObserver = new MutationObserver(() => {
        handleScroll();
    });

    if (customPlacementWrapper) {
        placementObserver.observe(customPlacementWrapper, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style']
        });
    }

    document.addEventListener('monogram:updated', () => {
        setTimeout(handleScroll, 100);
    });

    setTimeout(handleScroll, 600);

    this._stickyCleanup = function() {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
        placementObserver.disconnect();
        swiperObserver.disconnect();
        
        const thumbSwiperEl = document.querySelector('.p-info-thumb');
        if (thumbSwiperEl && thumbSwiperEl.swiper) {
            if (thumbSwiperEl._stickySlideChangeHandler) {
                thumbSwiperEl.swiper.off('slideChange', thumbSwiperEl._stickySlideChangeHandler);
                thumbSwiperEl._stickySlideChangeHandler = null;
            }
            if (thumbSwiperEl._stickySlideEndHandler) {
                thumbSwiperEl.swiper.off('slideChangeTransitionEnd', thumbSwiperEl._stickySlideEndHandler);
                thumbSwiperEl._stickySlideEndHandler = null;
            }
        }
        
        setSticky(false);
        body.classList.remove('sticky-monogram-active');
    };
  }


  /*
  variantLabelHover() {
    if (window.innerWidth < 989) return;

    const variantInners = this.querySelectorAll('.pinfo-variant-inner');
    
    variantInners.forEach((variantInner) => {
      const selectedValue = variantInner.querySelector('.pinfo-selected-value');
      if (!selectedValue) return;
      
      const originalText = selectedValue.textContent;
      const variantValues = variantInner.querySelectorAll('.p-info-variant-value');
      
      variantValues.forEach((variantValue) => {
        const input = variantValue.querySelector('input');
        if (!input) return;
        
        variantValue.addEventListener('mouseenter', () => {
          const inputValue = input.value;
          if (inputValue) selectedValue.textContent = inputValue;
        });
        
        variantValue.addEventListener('mouseleave', () => {
          selectedValue.textContent = originalText;
        });
      });
    });
  }
  */

  variantLabelHover() {
    if (window.innerWidth < 989) return;

    const groups = this.querySelectorAll('.color-group-container, .pinfo-variant-inner');
    
    groups.forEach((group) => {
      const selectedValue = group.querySelector('.pinfo-selected-value');
      if (!selectedValue) return;
      
      const originalText = selectedValue.textContent;
      
      const variantValues = group.querySelectorAll('.p-info-variant-value');
      
      variantValues.forEach((variantValue) => {
        const input = variantValue.querySelector('input');
        if (!input) return;
        
        variantValue.addEventListener('mouseenter', () => {
          const inputValue = input.value;
          if (inputValue) selectedValue.textContent = inputValue;
        });
        
        variantValue.addEventListener('mouseleave', () => {
          selectedValue.textContent = originalText;
        });
      });
    });
  }

  initFAQToggle() {
    const reviewApp = this.querySelector('.p-info-review-app');
    if (!reviewApp) return;

    const faqWrap = document.querySelector('.faq__wrapp-review');
    if (!faqWrap) return;

    const faqTitle = faqWrap.querySelector('[data-faq-title]');
    if (!faqTitle) return;

    reviewApp.addEventListener('click', (e) => {
      if (!faqTitle.classList.contains('active')) {
        faqTitle.click();
      }
    });
  }


  removeHiddenQuantitySelector() {
    const isMobile = window.innerWidth <= 1200;

    if (isMobile) {
      const desktopWrapper = this.querySelector('.quantity-selector-wrapper.sm-hide');
      if (desktopWrapper) desktopWrapper.remove();
    } else {
      const mobileWrapper = this.querySelector('.quantity-selector-wrapper.lg-hide');
      if (mobileWrapper) mobileWrapper.remove();
    }
  }


  /*
  initQuantitySelector() {
    const qtyWrapper = this.querySelector('[data-quantity-selector]');
    if (!qtyWrapper) return;
    const input = qtyWrapper.querySelector('.qty-input');
    const decreaseBtn = qtyWrapper.querySelector('.decrease');
    const increaseBtn = qtyWrapper.querySelector('.increase');
    decreaseBtn.addEventListener('click', () => {
      let currentVal = parseInt(input.value) || 1;
      if (currentVal > parseInt(input.min || 1)) {
        input.value = currentVal - 1;
        this.dispatchQuantityChange(input.value);
      }
    });
    increaseBtn.addEventListener('click', () => {
      let currentVal = parseInt(input.value) || 1;
      input.value = currentVal + 1;
      this.dispatchQuantityChange(input.value);
    });
    input.addEventListener('input', () => {
      if (input.value < 1) input.value = 1;
      this.dispatchQuantityChange(input.value);
    });
  }
  */


  initQuantitySelector() {
    const qtyWrapper = this.querySelector('[data-quantity-selector]');
    if (!qtyWrapper) return;
    
    // Remove any existing delegation listener
    if (this._quantityDelegationHandler) {
      qtyWrapper.removeEventListener('click', this._quantityDelegationHandler);
    }
    
    const input = qtyWrapper.querySelector('.qty-input');

    const updateAllQuantityInputs = (value) => {
      const allForms = document.querySelectorAll('form[action$="/cart/add"]');
      allForms.forEach(form => {
        const qtyInput = form.querySelector('input[name="quantity"]');
        if (qtyInput) {
          qtyInput.value = value;
        }
      });
    };

    // Single event delegation handler for both buttons
    this._quantityDelegationHandler = (e) => {
      const target = e.target;
      
      if (target.classList.contains('decrease')) {
        let currentVal = parseInt(input.value) || 1;
        if (currentVal > parseInt(input.min || 1)) {
          input.value = currentVal - 1;
          updateAllQuantityInputs(input.value);
          this.dispatchQuantityChange(input.value);
        }
      } else if (target.classList.contains('increase')) {
        let currentVal = parseInt(input.value) || 1;
        input.value = currentVal + 1;
        updateAllQuantityInputs(input.value);
        this.dispatchQuantityChange(input.value);
      }
    };
    
    qtyWrapper.addEventListener('click', this._quantityDelegationHandler);
    
    // Input listener - safe to add directly
    input.addEventListener('input', () => {
      if (input.value < 1) input.value = 1;
      updateAllQuantityInputs(input.value);
      this.dispatchQuantityChange(input.value);
    });

    updateAllQuantityInputs(input.value);
  }

  dispatchQuantityChange(value) {
    this.dispatchEvent(new CustomEvent('quantity-change', {
      detail: { quantity: Number(value) },
      bubbles: true
    }));
  }

  handleActionPopup() {
    const openButtons = this.querySelectorAll("[open-action-popup]");
    const closeButtons = this.querySelectorAll("[close-action-popup]");
    const popup = this.querySelector(".action__popup");
    const body = document.body;
    let isProcessing = false;

    const waitForTransition = (element, property) => {
      return new Promise((resolve) => {
        const handler = (e) => {
          if (
            e.target === element &&
            (!property || e.propertyName === property)
          ) {
            element.removeEventListener("transitionend", handler);
            resolve();
          }
        };
        element.addEventListener("transitionend", handler);
        setTimeout(resolve, 1000);
      });
    };

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const openPopup = async () => {
      if (isProcessing || popup.classList.contains("active")) return;
      isProcessing = true;

      const existingOverlay = document.querySelector(".custom-overlay");
      if (existingOverlay) existingOverlay.remove();
      const overlay = document.createElement("div");
      overlay.className = "custom-overlay";
      document.body.appendChild(overlay);

      overlay.classList.add("active");
      await waitForTransition(overlay, "opacity");

      popup.classList.add("active");
      await waitForTransition(popup, "max-height");

      closeButtons.forEach((btn) => btn.classList.add("visible"));
      await waitForTransition(closeButtons[0], "opacity");

      await delay(150);
      body.classList.add("overflow-hidden");

      await delay(150);
      const video = popup.querySelector(".action-video");
      if (video) {
        video.currentTime = 0;
        video.play().catch((error) => console.log("Video play failed:", error));
      }

      isProcessing = false;
    };

    const closePopup = async () => {
      if (isProcessing || !popup.classList.contains("active")) return;
      isProcessing = true;

      const video = popup.querySelector(".action-video");
      if (video) video.pause();

      popup.classList.remove("active");
      await waitForTransition(popup, "max-height");

      closeButtons.forEach((btn) => btn.classList.remove("visible"));
      await waitForTransition(closeButtons[0], "opacity");

      await delay(150);
      body.classList.remove("overflow-hidden");

      const overlay = document.querySelector(".custom-overlay");
      if (overlay) {
        overlay.classList.remove("active");
        await waitForTransition(overlay, "opacity");
        overlay.remove();
      }

      isProcessing = false;
    };

    openButtons.forEach((button) => {
      button.addEventListener("click", openPopup);
    });

    closeButtons.forEach((button) => {
      button.addEventListener("click", closePopup);
    });

    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("custom-overlay")) {
        closePopup();
      }
    });
  }

  handleSizeOption() {
    this.pqaOpener = this.querySelectorAll("[open-pqa-popup]");
    this.pqaPopUp = document.querySelector(".pqa-popup");

    if (this.pqaOpener && this.pqaPopUp) {
      this.pqaOpener.forEach((opener) => {
        opener.addEventListener("click", () => {
          if (!this.pqaPopUp.classList.contains("active")) {
            this.pqaPopUp.classList.add("active");
            document.querySelector("body").style.height = "100svh";
            document.querySelector("body").style.overflow = "hidden";
          }
        });
      });
    }
  }


  
  // handleEvents() {
  //   this.querySelector("form").addEventListener(
  //     "submit",
  //     this.handleAddToCart.bind(this)
  //   );
  // }
  
  

  handleEvents() {
    const form = this.querySelector('form[action$="/cart/add"]');
    if (!form) return;

    if (this._boundHandleAddToCart) {
      form.removeEventListener('submit', this._boundHandleAddToCart);
    }

    this._boundHandleAddToCart = this.handleAddToCart.bind(this);
    form.addEventListener('submit', this._boundHandleAddToCart);
  }

  handleAddToCart(e) {
    e.preventDefault();

    const btn = this.querySelector('button[type="submit"]');
    const originalText = btn ? btn.textContent : null;

    if (btn) {
      btn.classList.add("loading");
      btn.textContent = "Adding To Bag ...";
      btn.style.pointerEvents = "none";
      btn.style.opacity = ".7";
    }

    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    const addToCartForm = this.querySelector('form[action$="/cart/add"]');
    const formData = new FormData(addToCartForm);

    const qtyInput = this.querySelector('.quantity-selector .qty-input');
    if (qtyInput) {
      formData.set('quantity', qtyInput.value);
    }

    if (this.cart) {
      formData.append(
        "sections",
        this.cart.getSectionsToRender().map((section) => section.id)
      );
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((r) => r.json())
      .then((response) => {
        this.cart.renderContents(response);
      })
      .finally(() => {
        
        if (btn) {
          btn.classList.remove("loading");
          btn.textContent = originalText ?? "Add To Bag";
          btn.style.pointerEvents = "";
          btn.style.opacity = "";
        }

        const cartIcon = document.querySelector(".header__icon--cart");
        if (cartIcon) cartIcon.click();

        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }
      });
  }


  handleVariantInput(e) {
    const { url, imageId } = e.target?.dataset;
    this.handleOptions(url, imageId);
  }

  getCurrentVariant() {
    try {
      const variantIdInput = this.querySelector('input[name="id"]');
      if (!variantIdInput || !variantIdInput.value) {
        console.warn("No variant selected");
        return null;
      }

      if (!window.productVariants || !window.productVariants.length) {
        console.error("Product variants not available");
        return null;
      }

      const variantId = parseInt(variantIdInput.value);
      const matchingVariant = window.productVariants.find(
        (variant) => variant.id === variantId
      );

      if (!matchingVariant) {
        console.warn("No matching variant found for ID:", variantId);
      }
      return matchingVariant || null;
    } catch (error) {
      console.error("Error in getCurrentVariant:", error);
      return null;
    }
  }

  handleOptions(url = null, imageId = null) {
    if (imageId && imageId !== null) this.handleActiveSlide(imageId);
    if (url && url !== null) this.handleOptionsUrl(url);
  }

  handleOptionsUrl(url) {
    if (!url || url === null) return;

    this.updateURL(url);
    this.handleQuickAdd(url);
  }

  handleQuickAdd(url) {
    const urlParams = new URLSearchParams(url.split('?')[1]);
    const variantId = urlParams.get('variant');
    if (!variantId) return;

    const variant = window.productVariants?.find(
      (v) => v.id.toString() === variantId
    );
    
    if (variant) {
      this.fetchAndRender(url, variant.id);
    }
  }

  updateURL(url) {
    if (this.dataset.updateUrl === "false") return null;
    
    const collectionHandle = this.dataset.collectionHandle;
    
    if (collectionHandle && this.dataset.withinCollection) {
      const urlObj = new URL(url, window.location.origin);
      const variantParam = urlObj.searchParams.get('variant');
      const productHandle = url.split('?')[0].split('/').pop();
      const newUrl = `/collections/${collectionHandle}/products/${productHandle}${variantParam ? '?variant=' + variantParam : ''}`;
      
      window.history.replaceState({}, "", newUrl);  
    } else {
      window.history.replaceState({}, "", url);   
    }
  }

  async newRender(variantOrId) {
    const variantId = typeof variantOrId === 'object' ? variantOrId.id : variantOrId;
    const url = `${this.dataset.url}?variant=${variantId}`;
    
    await this.fetchAndRender(url, variantId);
  }

  
  async fetchAndRender(url, variantId) {
    // ── Detect whether customizer/placement is present on the page ──
    const hasCustomizer = !!document.querySelector('.customizer-groups-container');
    const hasPlacement = !!document.querySelector('.cpc-placement-wrapper');
    const hasAnyCustomizer = hasCustomizer || hasPlacement;

    // ── Detect whether this is a color change ──
    const isColorInput = !!document.activeElement?.classList?.contains('pinfo-color-input')
        || !!document.querySelector('.pinfo-color-input:checked[data-variant*="' + variantId + '"]');

    // ── Save current quantity value BEFORE any DOM updates ──
    const currentQtyInput = this.querySelector('.qty-input');
    const currentQtyValue = currentQtyInput ? currentQtyInput.value : '1';

    // ── Determine if we need to re-render media ──
    const shouldUpdateMedia = !hasAnyCustomizer || isColorInput;

    // ── Determine if we need to preserve customizer properties ──
    const shouldPreserveProperties = hasAnyCustomizer && !isColorInput;

    try {
        // Show loading state
        const variantPicker = this.querySelector("product-variant-picker");
        if (variantPicker) {
            variantPicker.style.opacity = "0.6";
            variantPicker.style.pointerEvents = "none";
        }

        const quickSectionEl = document.querySelector('.pdp-quick-add-section');
        const detailsSectionEl = document.querySelector('.pdp-details-section');

        const quickKey = quickSectionEl ? quickSectionEl.dataset.quickSectionId : null;
        const detailsKey = detailsSectionEl ? detailsSectionEl.dataset.detailsSectionId : null;

        const sections = [
            this.sectionId,
            quickKey,
            detailsKey
        ].filter(Boolean).join(',');

        const sectionUrl = `${url}&sections=${sections}`;
        const response = await fetch(sectionUrl);
        const data = await response.json();

        const mainSectionHtml = new DOMParser().parseFromString(
            data[this.sectionId],
            "text/html"
        );
        const quickAddHtml = new DOMParser().parseFromString(
            data[quickKey],
            "text/html"
        );
        const detailsHtml = new DOMParser().parseFromString(
            data[detailsKey],
            "text/html"
        );

        // ============================================================
        // UPDATE VARIANT PICKERS - ALWAYS RUN
        // ============================================================
        if (this.querySelector("product-variant-picker") && mainSectionHtml.querySelector("product-variant-picker")) {
            this.querySelector("product-variant-picker").innerHTML = mainSectionHtml.querySelector("product-variant-picker").innerHTML;
        }

        // ============================================================
        // UPDATE PRICES - ALWAYS RUN
        // ============================================================
        if (this.querySelectorAll(".p-info-price-wrapper")) {
            this.querySelectorAll(".p-info-price-wrapper").forEach((el) => {
                const priceWrapper = mainSectionHtml.querySelector(".p-info-price-wrapper");
                if (priceWrapper) {
                    el.innerHTML = priceWrapper.innerHTML;
                }
            });
        }

        // ============================================================
        // UPDATE INVENTORY STATUS - ALWAYS RUN
        // ============================================================
        if (this.querySelector(".--inventory-status-wrapper") && mainSectionHtml.querySelector(".--inventory-status-wrapper")) {
            this.querySelector(".--inventory-status-wrapper").innerHTML = mainSectionHtml.querySelector(".--inventory-status-wrapper").innerHTML;
        }

        // ============================================================
        // UPDATE EMBROIDERY MESSAGE - ALWAYS RUN
        // ============================================================
        if (this.querySelector(".--embroidery-message-container") && mainSectionHtml.querySelector(".--embroidery-message-container")) {
            this.querySelector(".--embroidery-message-container").innerHTML = mainSectionHtml.querySelector(".--embroidery-message-container").innerHTML;
        }

        // ============================================================
        // UPDATE PRODUCT DETAILS - ALWAYS RUN
        // ============================================================
        if (document.querySelector(".product-details-new .pd__feature-image") && detailsHtml.querySelector(".product-details-new .pd__feature-image")) {
            document.querySelector(".product-details-new .pd__feature-image").innerHTML = detailsHtml.querySelector(".product-details-new .pd__feature-image").innerHTML;
        }

        // ============================================================
        // UPDATE DISCOUNT CODE - ALWAYS RUN
        // ============================================================
        if (this.querySelector(".--discount-code-container") && mainSectionHtml.querySelector(".--discount-code-container")) {
            this.querySelector(".--discount-code-container").innerHTML = mainSectionHtml.querySelector(".--discount-code-container").innerHTML;
        }

        // ============================================================
        // UPDATE MEDIA - ONLY ON COLOR CHANGE OR NO CUSTOMIZER
        // ============================================================
        if (shouldUpdateMedia) {
            if (this.querySelector(".p-info-media") && mainSectionHtml.querySelector(".p-info-media")) {
                this.querySelector(".p-info-media").innerHTML = mainSectionHtml.querySelector(".p-info-media").innerHTML;
            }
            this.initZoomListeners();
            this.initThumbSlider();
        }

        this.handleActionPopup();

        // ============================================================
        // UPDATE FORM - Beta uses product-info-form custom element
        // ============================================================
        const productInfoForm = this.querySelector("product-info-form");
        if (productInfoForm) {
            const formHtml = mainSectionHtml.querySelector("product-info-form");
            if (formHtml) {
                // ── Check availability from new HTML ──
                const isVariantAvailable = formHtml.classList.contains('variant-available');

                // ── Save customizer properties if we need to preserve them ──
                let savedPropsHTML = null;
                if (shouldPreserveProperties) {
                    const masterContainer = productInfoForm.querySelector('.customizer-properties');
                    savedPropsHTML = masterContainer ? masterContainer.innerHTML : null;
                }

                // ── Full re-render of the form ──
                productInfoForm.innerHTML = formHtml.innerHTML;

                // ── Update class on product-info-form ──
                productInfoForm.classList.toggle('variant-available', isVariantAvailable);
                productInfoForm.classList.toggle('variant-sold-out', !isVariantAvailable);

                // ── Re-inject customizer properties if preserved ──
                if (shouldPreserveProperties) {
                    const form = productInfoForm.querySelector('form[action$="/cart/add"]');
                    if (form) {
                        let propsContainer = form.querySelector('.customizer-properties');
                        if (!propsContainer) {
                            propsContainer = document.createElement('div');
                            propsContainer.className = 'customizer-properties';
                            propsContainer.style.display = 'none';
                            form.appendChild(propsContainer);
                        }
                        if (savedPropsHTML) {
                            propsContainer.innerHTML = savedPropsHTML;
                        } else if (hasCustomizer && typeof window.__customizerWriteProperties === 'function') {
                            window.__customizerWriteProperties();
                        }
                    }
                }

                // ── Update quantity wrapper visibility based on stock ──
                const qtyWrapper = document.querySelector('.quantity-selector-wrapper');
                if (qtyWrapper) {
                    if (!isVariantAvailable) {
                        qtyWrapper.classList.add("hidden");
                    } else {
                        qtyWrapper.classList.remove("hidden");
                    }
                }

                // ── Recheck customizer/placement ──
                if (hasCustomizer && typeof window.__appCustomizerRecheck === 'function') {
                    setTimeout(function () {
                        window.__appCustomizerRecheck();
                    }, 100);
                }

                if (hasPlacement && typeof window.__placementRecheck === 'function') {
                    setTimeout(function () {
                        window.__placementRecheck();
                    }, 100);
                }

                // ── Reinitialize payment buttons ──
                if (window.Shopify && Shopify.PaymentButton) {
                    Shopify.PaymentButton.init();
                }
            }
        }

        // ============================================================
        // UPDATE PQA - ALWAYS RUN
        // ============================================================
        if (document.querySelector("pqa-new")) {
            const pqaHtml = quickAddHtml.querySelector("pqa-new");
            if (pqaHtml) {
                document.querySelector("pqa-new").innerHTML = pqaHtml.innerHTML;

                // Re-sync customizer properties into the PQA form after innerHTML replace
                const sourceContainer = document.querySelector('form[action$="/cart/add"] .customizer-properties');
                const pqaForm = document.querySelector('pqa-new form[action$="/cart/add"]');
                if (sourceContainer && pqaForm) {
                    let mirror = pqaForm.querySelector('.customizer-properties');
                    if (!mirror) {
                        mirror = document.createElement('div');
                        mirror.className = 'customizer-properties';
                        mirror.style.display = 'none';
                        pqaForm.appendChild(mirror);
                    }
                    mirror.innerHTML = sourceContainer.innerHTML;
                }
            }
        }

        // ============================================================
        // UPDATE MODEL INFO - ALWAYS RUN
        // ============================================================
        if (this.querySelector(".p-model-info.desktop-model") && mainSectionHtml.querySelector(".p-model-info.desktop-model")) {
            this.querySelector(".p-model-info.desktop-model").innerHTML = mainSectionHtml.querySelector(".p-model-info.desktop-model").innerHTML;
        }

        // ============================================================
        // STOCK NOTIFY - ALWAYS RUN
        // ============================================================
        if (document.querySelector("stock-notify")) {
            const currentVariant = this.getCurrentVariant();
            if (currentVariant) {
                console.log("Variant Changed to ", currentVariant);
                if (typeof notifyPopup === 'function') {
                    notifyPopup(currentVariant);
                }
            }
        }

        // ============================================================
        // RE-ATTACH EVENT HANDLERS - ALWAYS RUN
        // ============================================================
        this.handleEvents();

        if (this.querySelector("product-variant-picker")) {
            this.querySelector("product-variant-picker").style.opacity = "1";
            this.querySelector("product-variant-picker").style.pointerEvents = "inherit";
        }

        // ============================================================
        // RE-INITIALIZE QUANTITY SELECTOR - ALWAYS RUN
        // ============================================================
        this.initQuantitySelector();

        const newQtyInput = this.querySelector('.qty-input');
        if (newQtyInput && currentQtyValue) {
            newQtyInput.value = currentQtyValue;
            this.dispatchQuantityChange(parseInt(currentQtyValue));
        }

        // ============================================================
        // RE-INITIALIZE COMPONENTS
        // ============================================================
        this.initZoomListeners();
        this.initThumbSlider();
        this.variantLabelHover();
        this.handleActionPopup();
        this.initFAQToggle();
        this.initStickyMobilePreview();

        if (typeof scrolltoReviewSection === 'function') {
            window.scrolltoReviewSection(5, 1000);
        }
        if (typeof sizeGuide === 'function') {
            sizeGuide();
        }
        if (typeof initAccordion === 'function') {
            initAccordion();
        }
        if (typeof window.globalAtcRemoveFunc === 'function') {
            window.globalAtcRemoveFunc();
        }
        if (typeof yotpoWidgetsContainer !== 'undefined') {
            yotpoWidgetsContainer.initWidgets();
        }

        // ============================================================
        // CUSTOMIZER - RE-RUN ONLY ON COLOR CHANGE
        // ============================================================
        if (isColorInput) {
            if (hasCustomizer && typeof window.appCustomizer === "function") {
                window.appCustomizer();
            }

            if (hasPlacement && window.CustomPlacement && window.CustomPlacement.instance) {
                window.CustomPlacement.instance.reattachEventListeners();
                window.CustomPlacement.instance.recheckState();
            }

            // Reinit monogram slides for custom-placement
            if (hasPlacement) {
                const thumbEl = this.querySelector('.p-info-thumb');
                if (thumbEl && thumbEl.swiper) {
                    setTimeout(function () {
                        thumbEl.swiper.update();
                    }, 200);
                }
            }
        }

        // ============================================================
        // DISPATCH VARIANT CHANGE EVENT
        // ============================================================
        const variantIdForEvent = this.querySelector('input[name="id"]')?.value;
        if (variantIdForEvent) {
            document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId: variantIdForEvent } }));
        }

    } catch (error) {
        console.error('Error fetching variant data:', error);
    } finally {
        window.initAccordion();
        const variantPicker = this.querySelector("product-variant-picker");
        if (variantPicker) {
            variantPicker.style.opacity = "1";
            variantPicker.style.pointerEvents = "inherit";
        }
    }
}
  
  

  handleActiveSlide(imageId) {
    if (!imageId || imageId === null) return;
    let activeSlide = this.querySelector(
      `.p-info-thumb .swiper-slide[data-image-id="${imageId}"]`
    );
    // if (activeSlide) this.gotoActiveSlide(activeSlide.dataset?.index);
  }

  gotoActiveSlide(index) {
    // if (index && this.thumbSwiper) this.thumbSwiper.slideTo(index);
  }

  initThumbSlider() {
    const thumbEl = this.querySelector('.p-info-thumb');
    if (!thumbEl) return;

    if (this.thumbSwiper) {
      try {
        this.thumbSwiper.destroy(true, true);
      } catch (e) {}
      this.thumbSwiper = null;
    }
    if (thumbEl.swiper) {
      try {
        thumbEl.swiper.destroy(true, true);
      } catch (e) {}
    }

    const paginationEl = thumbEl.querySelector('.swiper-pagination');
    const nextEl = thumbEl.querySelector('.swiper-button-next');
    const prevEl = thumbEl.querySelector('.swiper-button-prev');

    const hasSingleSlide = thumbEl.hasAttribute('data-single-slide')
      || !!thumbEl.querySelector('[data-single-slide], [data-single-slide="true"]');

    const baseConfig = {
      slidesPerView: 'auto',
      spaceBetween: 0,
      autoHeight: true,
      watchOverflow: false,
      initialSlide: 0,
      pagination: {
        el: paginationEl,
        type: 'fraction',
        clickable: true,
        formatFractionTotal: function () {
          const sw = thumbEl.swiper;
          return sw && sw.slides ? sw.slides.length : 0;
        },
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        0:   { slidesPerView: 1, spaceBetween: 0, autoHeight: false, grabCursor: true, },
        500: { slidesPerView: 1, spaceBetween: 0, autoHeight: false, freeMode: true, },
        650: { slidesPerView: 1, spaceBetween: 0, autoHeight: false, freeMode: true, },
        769: { slidesPerView: 'auto', spaceBetween: 0, grabCursor: true, freeMode: true, },
      },
    };

    const singleSlideOverrides = hasSingleSlide ? {
      slidesPerView: 1,
      loop: false,
      breakpoints: {
        0:   { slidesPerView: 1, autoHeight: true, spaceBetween: 0, autoHeight: false },
        500: { slidesPerView: 1, autoHeight: true, spaceBetween: 0, autoHeight: false },
        769: { slidesPerView: 1, autoHeight: true, spaceBetween: 0 },
      },
    } : {};

    this.thumbSwiperConfig = { ...baseConfig, ...singleSlideOverrides };
    this.thumbSwiper = new Swiper(thumbEl, this.thumbSwiperConfig);

    this.pinPreviewSlide();
  }



  pinPreviewSlide() {
    const thumbEl = this.querySelector('.p-info-thumb');
    if (!thumbEl) return;
    if (!thumbEl.querySelector('.customizer-preview-image')) return;

    const pin = () => {
      const sw = thumbEl.swiper || this.thumbSwiper;
      if (!sw || sw.destroyed) return;
      if (sw.activeIndex !== 0 || sw.translate !== 0) {
        sw.update();
        sw.slideTo(0, 0, false);
        if (sw.translate !== 0) sw.setTranslate(0);
      }
    };

    requestAnimationFrame(pin);
    setTimeout(pin, 150);
    setTimeout(pin, 400);
  }
  
  /*
  initThumbSlider() {
    const thumbEl = this.querySelector('.p-info-thumb');
    if (!thumbEl) return;

    if (this.thumbSwiper) {
      try {
        this.thumbSwiper.destroy(true, true);
      } catch (e) {}
      this.thumbSwiper = null;
    }
    if (thumbEl.swiper) {
      try {
        thumbEl.swiper.destroy(true, true);
      } catch (e) {}
    }

    const paginationEl = thumbEl.querySelector('.swiper-pagination');
    const nextEl = thumbEl.querySelector('.swiper-button-next');
    const prevEl = thumbEl.querySelector('.swiper-button-prev');

    const hasSingleSlide = thumbEl.hasAttribute('data-single-slide')
      || !!thumbEl.querySelector('[data-single-slide], [data-single-slide="true"]');

    const baseConfig = {
      slidesPerView: 'auto',
      spaceBetween: 0,
      autoHeight: true,
      watchOverflow: false,
      pagination: {
        el: paginationEl,
        type: 'fraction',
        clickable: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        0:   { slidesPerView: 1, spaceBetween: 0, autoHeight: false, grabCursor: true, },
        500: { slidesPerView: 1, spaceBetween: 0, autoHeight: false, freeMode: true, },
        650: { slidesPerView: 1, spaceBetween: 0, autoHeight: false, freeMode: true, },
        769: { slidesPerView: 'auto', spaceBetween: 0, grabCursor: true, freeMode: true, },
      },
    };

    const singleSlideOverrides = hasSingleSlide ? {
      slidesPerView: 1,
      loop: false,
      breakpoints: {
        0:   { slidesPerView: 1, autoHeight: true, spaceBetween: 0, autoHeight: false },
        500: { slidesPerView: 1, autoHeight: true, spaceBetween: 0, autoHeight: false },
        769: { slidesPerView: 1, autoHeight: true, spaceBetween: 0 },
      },
    } : {};

    this.thumbSwiperConfig = { ...baseConfig, ...singleSlideOverrides };
    this.thumbSwiper = new Swiper(thumbEl, this.thumbSwiperConfig);
  }
  */

  /*
  initZoomListeners() {
    this.customCursorBreakpoint = 1200;
    this.querySelectorAll('.p-info-thumb-slide').forEach(slide => {
      slide.addEventListener('click', this.handleImageClick.bind(this));
    });
  }*/

  initZoomListeners() {
    this.customCursorBreakpoint = 1200;
    this.querySelectorAll('.p-info-thumb-slide').forEach(slide => {

      // Remove previous listener if exists
      if (slide._zoomClickHandler) {
        slide.removeEventListener('click', slide._zoomClickHandler);
      }

      // Store reference so we can remove it next time
      slide._zoomClickHandler = this.handleImageClick.bind(this);
      slide.addEventListener('click', slide._zoomClickHandler);
    });
  }

  createCustomCursor() {
    if (this.customCursor) return;
    if (window.innerWidth < this.customCursorBreakpoint) return;
    
    this.customCursor = document.createElement('div');
    this.customCursor.className = 'custom-zoom-cursor';
    document.body.appendChild(this.customCursor);
    
    this.setCursorPlus();
  }

  removeCustomCursor() {
    if (this.customCursor) {
      this.customCursor.remove();
      this.customCursor = null;
    }
  }

  updateCursorPosition(e) {
    if (!this.customCursor) return;
    this.customCursor.style.left = (e.clientX - 16) + 'px';
    this.customCursor.style.top = (e.clientY - 16) + 'px';
  }

  setCursorPlus() {
    if (!this.customCursor) return;
    this.customCursor.innerHTML = `
      <svg class="cursor-svg" fill="#000000" width="24px" height="24px" viewBox="0 0 24 24" id="plus" data-name="Line Color" xmlns="http://www.w3.org/2000/svg" class="icon line-color"><path id="primary" d="M5,12H19M12,5V19" style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></path></svg>
    `;
  }

  setCursorMinus() {
    if (!this.customCursor) return;
    this.customCursor.innerHTML = `
      <svg class="cursor-svg" fill="#000000" width="24px" height="24px" viewBox="0 0 24 24" id="minus" data-name="Line Color" xmlns="http://www.w3.org/2000/svg" class="icon line-color"><line id="primary" x1="19" y1="12" x2="5" y2="12" style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></line></svg>
    `;
  }

  handleImageClick(e) {
    const slide = e.currentTarget;
    
    // Skip monogram slides - they shouldn't open zoom popup
    if (slide.classList.contains('cpc-monogram-slide-wrapper') || slide.closest('.cpc-monogram-slide-wrapper')) {
        return;
    }
    
    // Video slides should still open the popup but not zoom
    const allSlides = Array.from(this.querySelectorAll('.p-info-thumb-slide'));
    const clickedIndex = allSlides.indexOf(slide);
    this.openZoomPopup(clickedIndex);
  }

  openZoomPopup(initialIndex) {
      if (this.zoomPopup) {
          this.closeZoomPopup();
      }

      this.zoomPopup = document.createElement('div');
      this.zoomPopup.classList.add('zoom-popup');

      const swiperContainer = document.createElement('div');
      swiperContainer.classList.add('swiper', 'zoom-swiper');

      const wrapper = document.createElement('div');
      wrapper.classList.add('swiper-wrapper');

      let thumbSlides = Array.from(this.querySelectorAll('.p-info-thumb-slide'));

      thumbSlides.forEach((thumb, idx) => {
          const slide = document.createElement('div');
          slide.classList.add('swiper-slide', 'zoom-slide');
          
          /*
          // Skip monogram slides - they shouldn't be zoomable
          if (thumb.classList.contains('cpc-monogram-slide-wrapper') || thumb.closest('.cpc-monogram-slide-wrapper')) {
            slide.classList.add('zoom-non-zoomable');
            slide.style.cursor = 'default';
            const clone = thumb.cloneNode(true);
            // Remove any interactive elements
            const interactiveElements = clone.querySelectorAll('button, input, .cpc-char-input, .cpc-category-btn, .cpc-font-card, .cpc-color-swatch, .cpc-placement-btn, .cpc-clear-btn, .cpc-form-body, .cpc-section, .cpc-section-header, .cpc-section-current, .cpc-char-input-wrap, .cpc-char-counter, .cpc-validation-message, .cpc-allowed-chars, .cpc-char-hint, .cpc-clear-btn, .cpc-color-swatch-wrapper, .swiper-wrapper, .swiper-slide, .swiper-scrollbar, .cpc-placement-icon, .cpc-placement-label, .cpc-font-preview, .cpc-font-name, .cpc-category-btn, .cpc-font-card, .cpc-color-swatch, .cpc-placement-btn');
            interactiveElements.forEach(el => el.remove());
            // Remove empty containers that might have been left
            const emptySections = clone.querySelectorAll('.cpc-section:empty, .cpc-section-header:empty, .slider-track:empty');
            emptySections.forEach(el => el.remove());
            slide.appendChild(clone);
            wrapper.appendChild(slide);
            return;
          }
          */


          // Skip monogram slides - they shouldn't be zoomable
          if (thumb.classList.contains('cpc-monogram-slide-wrapper') || thumb.closest('.cpc-monogram-slide-wrapper')) {
            slide.classList.add('zoom-non-zoomable');
            slide.style.cursor = 'default';
            const clone = thumb.cloneNode(true);
            // Remove any interactive elements
            const interactiveElements = clone.querySelectorAll('button, input, .cpc-char-input, .cpc-category-btn, .cpc-font-card, .cpc-color-swatch, .cpc-placement-btn, .cpc-clear-btn, .cpc-form-body, .cpc-section, .cpc-section-header, .cpc-section-current, .cpc-char-input-wrap, .cpc-char-counter, .cpc-validation-message, .cpc-allowed-chars, .cpc-char-hint, .cpc-clear-btn, .cpc-color-swatch-wrapper, .swiper-wrapper, .swiper-slide, .swiper-scrollbar, .cpc-placement-icon, .cpc-placement-label, .cpc-font-preview, .cpc-font-name, .cpc-category-btn, .cpc-font-card, .cpc-color-swatch, .cpc-placement-btn');
            interactiveElements.forEach(el => el.remove());
            // Remove empty containers that might have been left
            const emptySections = clone.querySelectorAll('.cpc-section:empty, .cpc-section-header:empty, .slider-track:empty');
            emptySections.forEach(el => el.remove());

            // cloneNode copies the DOM but NOT a canvas bitmap, so the
            // embroidery canvases come through blank. Repaint them from
            // the originals. (SVG monograms are real DOM and clone fine.)
            const srcCanvases = thumb.querySelectorAll('canvas');
            const dstCanvases = clone.querySelectorAll('canvas');
            srcCanvases.forEach((src, i) => {
                const dst = dstCanvases[i];
                if (!dst || !src.width || !src.height) return;
                dst.width = src.width;
                dst.height = src.height;
                try {
                    dst.getContext('2d').drawImage(src, 0, 0);
                } catch (err) {
                    console.log('Canvas copy failed:', err);
                }
                if (src.classList.contains('active')) {
                    dst.classList.add('active');
                }
                dst.style.display = window.getComputedStyle(src).display;
            });

            slide.appendChild(clone);
            wrapper.appendChild(slide);
            return;
          }
          
          // Check if this is a video slide
          const isVideo = thumb.classList.contains('p-info-thumb-video') || 
                          thumb.querySelector('video');
          
          if (isVideo) {
              const video = thumb.querySelector('video');
              if (video) {
                  const clonedVideo = video.cloneNode(true);
                  clonedVideo.muted = true;
                  clonedVideo.controls = false;
                  clonedVideo.loop = true;
                  clonedVideo.autoplay = true;
                  clonedVideo.playsInline = true;
                  clonedVideo.style.width = '100%';
                  clonedVideo.style.height = '100%';
                  clonedVideo.style.objectFit = 'contain';
                  clonedVideo.style.maxHeight = '100vh';
                  clonedVideo.style.maxWidth = '100vw';
                  clonedVideo.dataset.videoSlide = 'true';
                  
                  const videoContainer = document.createElement('div');
                  videoContainer.style.width = '100%';
                  videoContainer.style.height = '100%';
                  videoContainer.style.display = 'flex';
                  videoContainer.style.alignItems = 'center';
                  videoContainer.style.justifyContent = 'center';
                  videoContainer.appendChild(clonedVideo);
                  
                  slide.appendChild(videoContainer);
                  slide.classList.add('zoom-video-slide');
                  slide.style.cursor = 'default';
                  slide.dataset.videoIndex = idx;
              }
          } else {
              const img = thumb.querySelector('img');
              if (img) {
                  const lowResSrc = img.currentSrc || img.src;
                  const highResSrc = img.dataset.highResSrc || lowResSrc.replace(/width=\d+/, 'width=2048');
                  
                  const bgDiv = document.createElement('div');
                  bgDiv.classList.add('zoom-bg-image');
                  bgDiv.style.backgroundImage = `url('${lowResSrc}')`;
                  bgDiv.dataset.lowResSrc = lowResSrc;
                  bgDiv.dataset.highResSrc = highResSrc;
                  bgDiv.dataset.currentRes = 'low';
                  
                  slide.appendChild(bgDiv);
              }
          }
          
          wrapper.appendChild(slide);
      });

      swiperContainer.appendChild(wrapper);

      const navWrapper = document.createElement('div');
      navWrapper.classList.add('zoom-swiper-nav');

      const navButtonsWrapper = document.createElement('div');
      navButtonsWrapper.classList.add('zoom-swiper-nav-buttons');

      const prev = document.createElement('div');
      prev.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M19 12L5 12M5 12L12 19M5 12L12 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>`;
      prev.classList.add('swiper-button-prev');
      navButtonsWrapper.appendChild(prev);

      const next = document.createElement('div');
      next.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                              <path d="M5 12.3H19M19 12.3L12 5.30005M19 12.3L12 19.3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>`;
      next.classList.add('swiper-button-next');
      navButtonsWrapper.appendChild(next);

      navWrapper.appendChild(navButtonsWrapper);

      const paginationWrapper = document.createElement('div');
      paginationWrapper.classList.add('zoom-swiper-nav-pagination');

      const pagination = document.createElement('div');
      pagination.classList.add('swiper-pagination');
      paginationWrapper.appendChild(pagination);

      navWrapper.appendChild(paginationWrapper);

      swiperContainer.appendChild(navWrapper);

      const close = document.createElement('button');
      close.classList.add('zoom-close');
      close.innerHTML = `<svg fill="#000000" width="32px" height="32px" viewBox="-6 -6 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>`;
      this.zoomPopup.appendChild(close);

      this.zoomPopup.appendChild(swiperContainer);
      document.body.appendChild(this.zoomPopup);

      const isMobile = window.innerWidth < 990;

      const swiperInstance = this;

      this.zoomSwiper = new Swiper(swiperContainer, {
          initialSlide: initialIndex,
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
          pagination: {
              el: '.swiper-pagination',
              type: 'fraction',
          },
          loop: false,
          allowTouchMove: true,
          touchRatio: isMobile ? 1 : 0,
          on: {
              slideChangeTransitionStart: function() {
                  swiperInstance.pauseAllVideos();
              },
              slideChangeTransitionEnd: function() {
                  swiperInstance.playActiveVideo();
              }
          }
      });

      setTimeout(() => {
          this.playActiveVideo();
      }, 100);

      close.addEventListener('click', this.closeZoomPopup.bind(this));
      this.zoomPopup.addEventListener('click', (e) => {
          if (e.target === this.zoomPopup) {
              this.closeZoomPopup();
          }
      });

      const slides = swiperContainer.querySelectorAll('.zoom-slide');
      slides.forEach(sl => {
          // Only add zoom toggle to image slides, not video slides or non-zoomable slides
          if (!sl.classList.contains('zoom-video-slide') && !sl.classList.contains('zoom-non-zoomable')) {
              sl.addEventListener('click', this.toggleZoom.bind(this));
          }
          
          sl.addEventListener('mousemove', this.handleSlideMouseMove.bind(this));
          sl.addEventListener('mouseleave', this.handleSlideMouseLeave.bind(this));
          sl.addEventListener('touchstart', this.handleTouchStart.bind(this));
          sl.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
      });

      [close, navWrapper].forEach(el => {
          el.addEventListener('mouseenter', this.handleNavMouseEnter.bind(this));
          el.addEventListener('mouseleave', this.handleNavMouseLeave.bind(this));
      });

      swiperContainer.addEventListener('mousemove', this.handleSwiperMouseMove.bind(this));
      swiperContainer.addEventListener('mouseleave', this.handleSwiperMouseLeave.bind(this));

      document.body.classList.add('overflow-hidden');
  }

  handleSwiperMouseMove(e) {
    if (window.innerWidth < this.customCursorBreakpoint) return;
    
    const target = e.target;
    if (target.closest('.zoom-swiper-nav') || 
        target.closest('.zoom-close')) {
      this.removeCustomCursor();
      return;
    }
    
    if (!target.closest('.zoom-slide')) {
      this.createCustomCursor();
      this.setCursorPlus();
      this.updateCursorPosition(e);
    }
  }

  handleSwiperMouseLeave() {
    this.removeCustomCursor();
  }

  handleSlideMouseMove(e) {
      if (window.innerWidth < this.customCursorBreakpoint) return;
      
      const slide = e.currentTarget;
      
      // Skip cursor changes for non-zoomable slides (monogram)
      if (slide.classList.contains('zoom-non-zoomable')) {
          this.removeCustomCursor();
          return;
      }
      
      // Skip cursor changes for video slides
      if (slide.classList.contains('zoom-video-slide')) {
          this.removeCustomCursor();
          return;
      }
      
      const target = e.target;
      if (target.closest('.zoom-swiper-nav') || 
          target.closest('.zoom-close')) {
          this.removeCustomCursor();
          return;
      }
      
      this.createCustomCursor();
      this.updateCursorPosition(e);
      
      if (slide.classList.contains('zoomed')) {
          this.setCursorMinus();
          this.panImage(e);
      } else {
          this.setCursorPlus();
      }
  }


  handleSlideMouseLeave() {
    if (!this.zoomPopup.contains(document.elementFromPoint(event.clientX, event.clientY))) {
      this.removeCustomCursor();
    }
  }

  handleNavMouseEnter() {
    this.removeCustomCursor();
  }

  handleNavMouseLeave(e) {
    if (window.innerWidth < this.customCursorBreakpoint) return;
    
    if (e.relatedTarget && e.relatedTarget.closest('.zoom-slide')) {
      this.createCustomCursor();
      const slide = this.zoomSwiper.slides[this.zoomSwiper.activeIndex];
      if (slide && slide.classList.contains('zoomed')) {
        this.setCursorMinus();
      } else {
        this.setCursorPlus();
      }
    }
  }

  closeZoomPopup() {
    // Pause all videos before closing
    this.pauseAllVideos();
    
    if (this.zoomSwiper) {
      // Remove event listeners
      this.zoomSwiper.off('slideChangeTransitionStart');
      this.zoomSwiper.off('slideChangeTransitionEnd');
      this.zoomSwiper.destroy(true, true);
      this.zoomSwiper = null;
    }
    if (this.zoomPopup) {
      this.zoomPopup.remove();
      this.zoomPopup = null;
    }
    this.removeCustomCursor();
    document.body.classList.remove('overflow-hidden');
    this.currentZoom = 1;
  }

  pauseAllVideos() {
    if (this.zoomPopup) {
      const videos = this.zoomPopup.querySelectorAll('video');
      videos.forEach(video => {
        video.pause();
      });
    }
  }

  playActiveVideo() {
    if (!this.zoomSwiper) return;
    
    // Get the active slide
    const activeIndex = this.zoomSwiper.activeIndex;
    const activeSlide = this.zoomSwiper.slides[activeIndex];
    
    if (!activeSlide) return;
    
    // Check if the active slide is a video slide
    if (activeSlide.classList.contains('zoom-video-slide')) {
      const video = activeSlide.querySelector('video');
      if (video) {
        // Reset video to beginning and play
        video.currentTime = 0;
        video.play().catch(error => {
          // Autoplay might be blocked by browser, but we still want to try
          console.log('Video autoplay blocked:', error);
          // Try again with user interaction
          document.addEventListener('click', function playOnClick() {
            video.play().catch(() => {});
            document.removeEventListener('click', playOnClick);
          }, { once: true });
        });
      }
    }
  }
  

  zoomOutIfZoomed() {
      const allSlides = this.zoomSwiper.slides;
      allSlides.forEach(slide => {
          if (slide.classList.contains('zoomed')) {
              const bgDiv = slide.querySelector('.zoom-bg-image');
              slide.classList.remove('zoomed');
              
              const lowResSrc = bgDiv.dataset.lowResSrc;
              if (bgDiv.dataset.currentRes === 'high' && lowResSrc) {
                  bgDiv.style.backgroundImage = `url('${lowResSrc}')`;
                  bgDiv.dataset.currentRes = 'low';
              }
              
              bgDiv.style.backgroundSize = 'contain';
              bgDiv.style.backgroundPosition = 'center';
          }
      });
      
      this.currentZoom = 1;
      this.updateSwiperTouchMove();
  }

  updateSwiperTouchMove() {
      const isMobile = window.innerWidth < 990;
      if (this.zoomSwiper) {
          if (isMobile) {
              this.zoomSwiper.params.touchRatio = this.currentZoom > 1 ? 0 : 1;
          } else {
              this.zoomSwiper.params.touchRatio = 0;
          }
          this.zoomSwiper.update();
      }
  }

  toggleZoom(e) {
      e.preventDefault();
      e.stopPropagation();
      const slide = e.currentTarget;
      
      // Skip non-zoomable slides (monogram)
      if (slide.classList.contains('zoom-non-zoomable')) {
          return;
      }
      
      const bgDiv = slide.querySelector('.zoom-bg-image');
      if (slide.classList.contains('zoomed')) {
          this.zoomOut(slide, bgDiv);
      } else {
          this.zoomIn(slide, bgDiv);
      }
  }

  zoomIn(slide, bgDiv) {
    this.currentZoom = 3;
    
    const highResSrc = bgDiv.dataset.highResSrc;
    const currentRes = bgDiv.dataset.currentRes;
    
    if (currentRes === 'low' && highResSrc && highResSrc !== bgDiv.dataset.lowResSrc) {
      const highResImg = new Image();
      highResImg.onload = () => {
        bgDiv.style.backgroundImage = `url('${highResSrc}')`;
        bgDiv.dataset.currentRes = 'high';
      };
      highResImg.src = highResSrc;
    }
    
    bgDiv.style.backgroundSize = `${this.currentZoom * 100}%`;
    bgDiv.style.backgroundPosition = 'center';
    slide.classList.add('zoomed');
    
    if (window.innerWidth >= this.customCursorBreakpoint) {
      this.setCursorMinus();
    }
    this.updateSwiperTouchMove();
  }

  zoomOut(slide, bgDiv) {
    this.currentZoom = 1;
    
    const lowResSrc = bgDiv.dataset.lowResSrc;
    const currentRes = bgDiv.dataset.currentRes;
    
    if (currentRes === 'high' && lowResSrc) {
      bgDiv.style.backgroundImage = `url('${lowResSrc}')`;
      bgDiv.dataset.currentRes = 'low';
    }
    
    bgDiv.style.backgroundSize = 'contain';
    bgDiv.style.backgroundPosition = 'center';
    slide.classList.remove('zoomed');
    
    if (window.innerWidth >= this.customCursorBreakpoint) {
      this.setCursorPlus();
    }
    this.updateSwiperTouchMove();
  }

  panImage(e) {
      if (this.currentZoom <= 1) return;
      
      const slide = this.zoomSwiper.slides[this.zoomSwiper.activeIndex];
      const bgDiv = slide.querySelector('.zoom-bg-image');
      const rect = slide.getBoundingClientRect();
      
      const xPercent = ((e.clientX - rect.left) / rect.width) * 100;
      const yPercent = ((e.clientY - rect.top) / rect.height) * 100;
      
      bgDiv.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
  }

  handleTouchStart(e) {
      // Skip non-zoomable slides (monogram)
      const slide = this.zoomSwiper?.slides[this.zoomSwiper?.activeIndex];
      if (slide?.classList.contains('zoom-non-zoomable')) {
          return;
      }
      
      if (e.touches.length === 2) {
          this.initialDistance = this.getTouchDistance(e.touches[0], e.touches[1]);
          this.initialZoom = this.currentZoom;
      } else if (e.touches.length === 1) {
          const activeSlide = this.zoomSwiper.slides[this.zoomSwiper.activeIndex];
          const bgDiv = activeSlide.querySelector('.zoom-bg-image');
          
          this.lastTouchX = e.touches[0].clientX;
          this.lastTouchY = e.touches[0].clientY;
          
          const bgPos = bgDiv.style.backgroundPosition || 'center';
          const parts = bgPos.split(' ');
          this.currentBgX = parseFloat(parts[0]) || 50;
          this.currentBgY = parseFloat(parts[1]) || 50;
      }
  }

  handleTouchMove(e) {
      e.preventDefault();
      const slide = this.zoomSwiper.slides[this.zoomSwiper.activeIndex];
      
      // Skip non-zoomable slides (monogram)
      if (slide.classList.contains('zoom-non-zoomable')) {
          return;
      }
      
      const bgDiv = slide.querySelector('.zoom-bg-image');
      const rect = slide.getBoundingClientRect();

      if (e.touches.length === 2) {
          const distance = this.getTouchDistance(e.touches[0], e.touches[1]);
          this.currentZoom = Math.max(1, Math.min(3, this.initialZoom * (distance / this.initialDistance)));
          
          if (this.currentZoom > 1) {
              slide.classList.add('zoomed');
              bgDiv.style.backgroundSize = `${this.currentZoom * 100}%`;
              this.zoomSwiper.params.allowTouchMove = false;
          } else {
              slide.classList.remove('zoomed');
              bgDiv.style.backgroundSize = 'contain';
              bgDiv.style.backgroundPosition = 'center';
              this.zoomSwiper.params.allowTouchMove = true;
          }
      } else if (e.touches.length === 1 && this.currentZoom > 1) {
          const deltaX = e.touches[0].clientX - this.lastTouchX;
          const deltaY = e.touches[0].clientY - this.lastTouchY;
          
          const deltaXPercent = (deltaX / rect.width) * 100 * (this.currentZoom * 0.5);
          const deltaYPercent = (deltaY / rect.height) * 100 * (this.currentZoom * 0.5);
          
          this.currentBgX -= deltaXPercent;
          this.currentBgY -= deltaYPercent;
          
          this.currentBgX = Math.max(0, Math.min(100, this.currentBgX));
          this.currentBgY = Math.max(0, Math.min(100, this.currentBgY));
          
          bgDiv.style.backgroundPosition = `${this.currentBgX}% ${this.currentBgY}%`;
          
          this.lastTouchX = e.touches[0].clientX;
          this.lastTouchY = e.touches[0].clientY;
      }
  }
  getTouchDistance(t1, t2) {
    return Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
  }

}



class ProductQuickAdd extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("input", this.handleVariantInput.bind(this));
    this.addEventListener("click", this.handleSubmitEvemt.bind(this));
  }

  handleVariantInput(e) {
    const { value } = e.target;
    if (document.querySelector("product-information"))
      document.querySelector("product-information").handleOptions(value);


    // this._syncCustomizerProperties();
  }

  _syncCustomizerProperties() {
    // Small delay to let fetchAndRender finish updating the main form first
    setTimeout(() => {
      const allForms = document.querySelectorAll('form[action$="/cart/add"]');
      if (allForms.length < 2) return;

      // The first form is always the source of truth (main product form)
      const sourceContainer = allForms[0].querySelector('.customizer-properties');
      if (!sourceContainer) return;

      allForms.forEach((form, i) => {
        if (i === 0) return; // skip source
        let mirror = form.querySelector('.customizer-properties');
        if (!mirror) {
          mirror = document.createElement('div');
          mirror.className = 'customizer-properties';
          mirror.style.display = 'none';
          form.appendChild(mirror);
        }
        mirror.innerHTML = sourceContainer.innerHTML;
      });
    }, 300);
  }

  handleSubmitEvemt(e) {
    if (e.target.closest("form")) {
      e.preventDefault();
    }

    if (e.target.tagName === "BUTTON") {
      this.handleAddToCart(e.target.closest("form"), e.target);
    }
    const btnPQA = e.target.classList.contains("pqa-popup-close")
      ? e.target
      : e.target.closest(".pqa-popup-close");
    if (btnPQA) {
      this.classList.remove("active");
      document.querySelector("body").style.height = "auto";
      document.querySelector("body").style.overflow = "auto";
    }
  }

  handleAddToCart(form, btn) {
    if (!form) return;

    if (btn) {
      if (!btn._originalText) {
        btn._originalText = btn.textContent;
      }

      btn.classList.add("loading");
      btn.textContent = "Adding To Bag ...";
      btn.style.pointerEvents = "none";
      btn.style.opacity = ".7";
    }

    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    const formData = new FormData(form);

    const qtyInput = document.querySelector(".quantity-selector .qty-input");
    if (qtyInput) {
      formData.set("quantity", qtyInput.value);
    }

    if (this.cart) {
      formData.append(
        "sections",
        this.cart.getSectionsToRender().map(section => section.id)
      );
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then(response => response.json())
      .then(response => {
        this.cart.renderContents(response);
      })
      .finally(() => {
        if (btn) {
          btn.classList.remove("loading");
          btn.textContent = btn._originalText;
          btn.style.pointerEvents = "auto";
          btn.style.opacity = "1";
        }

        document.querySelectorAll(".pqa-popup-close").forEach(popup__close => {
          popup__close.click();
        });

        document.querySelector(".header__icon--cart")?.click();

        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }
      });
  }



}

document.addEventListener("DOMContentLoaded", (e) => {
  customElements.define("product-information", ProductInformation);
  customElements.define("pqa-new", ProductQuickAdd);
});



(function syncSetProductSize() {

  function getPDPSize(variantId) {
    if (variantId && window.productVariants) {
      const variant = window.productVariants.find(v => v.id === parseInt(variantId));
      if (variant) {
        const picker = document.querySelector('product-information product-variant-picker');
        if (picker) {
          const wrappers = Array.from(picker.querySelectorAll('.pinfo-variant-inner'));
          for (let i = 0; i < wrappers.length; i++) {
            const label = wrappers[i].querySelector('.--option-name');
            if (label && label.textContent.toLowerCase().includes('size')) {
              return variant.options[i] || null;
            }
          }
        }
      }
    }

    const picker = document.querySelector('product-information product-variant-picker');
    if (picker) {
      const wrappers = Array.from(picker.querySelectorAll('.pinfo-variant-inner'));
      const sizeWrapper = wrappers.find(w => {
        const label = w.querySelector('.--option-name');
        return label && label.textContent.toLowerCase().includes('size');
      });
      if (sizeWrapper) {
        const checked = sizeWrapper.querySelector('input[type="radio"]:checked');
        if (checked) return checked.value;
      }
    }

    const idInput = document.querySelector('product-information input[name="id"]');
    if (idInput && window.productVariants) {
      const variant = window.productVariants.find(v => v.id === parseInt(idInput.value));
      if (variant) return variant.option2 || variant.option1 || null;
    }

    return null;
  }

  function applySizeToCard(card, size) {
    if (!card || !size) return;

    const radios = card.querySelectorAll('.size-radio');
    if (!radios.length) return;

    radios.forEach(radio => {
      const radioSize = (radio.dataset.sizeValue || '').trim().toUpperCase();
      if (radioSize !== size.trim().toUpperCase()) return;

      radio.checked = true;

      card.querySelectorAll('.selected_value-display').forEach(el => {
        el.textContent = radio.dataset.sizeValue;
      });

      radio.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function syncAllCards(variantId) {
    const size = getPDPSize(variantId);
    if (!size) return;

    const cards = document.querySelectorAll('.--set-product');
    if (!cards.length) return;

    cards.forEach(card => applySizeToCard(card, size));
  }

  function waitThen(ms, fn) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(fn, ms);
      });
    });
  }

  document.addEventListener('variant:change', function(e) {
    const variantId = e.detail && e.detail.variantId;
    waitThen(100, () => syncAllCards(variantId));
  });

  document.addEventListener('change', function(e) {
    const input = e.target;
    if (!input) return;
    if (!input.closest('product-information')) return;

    const parentWrapper = input.closest('.pinfo-variant-inner');
    if (!parentWrapper) return;

    const optionLabel = parentWrapper.querySelector('.--option-name');
    if (!optionLabel) return;
    if (!optionLabel.textContent.toLowerCase().includes('size')) return;

    const size = input.value;
    if (!size) return;

    const cards = document.querySelectorAll('.--set-product');
    if (!cards.length) return;

    cards.forEach(card => applySizeToCard(card, size));
  });

  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('.color-swatch');
    if (!swatch) return;

    const card = swatch.closest('.--set-product');
    if (!card) return;

    waitThen(80, () => {
      const size = getPDPSize(null);
      applySizeToCard(card, size);
    });
  });

})();




// Define the global function
window.globalAtcRemoveFunc = function () {
  document.querySelectorAll('.custom__atc-global-btn').forEach(btn => {
    btn.classList.remove('custom__atc-global-btn');
  });
};

// Run it once when the page fully loads
document.addEventListener('DOMContentLoaded', function () {
  window.globalAtcRemoveFunc();
   window.functionsWithRetry('handleWair');
});


